import React, { useState, createContext, useContext } from 'react'

import { DEFAULT_TOPIC } from './constants'

const ArticlesContext = createContext({})

export const ArticlesContextProvider = ({ children, initialPosts }) => {
  const [posts, setPosts] = useState(initialPosts.items)
  const [activeChip, setActiveChip] = useState(DEFAULT_TOPIC.slug)
  const [isLoading, setIsLoading] = useState(false)

  const fetchOnClick = slug => {
    let searchParams
    if (slug !== DEFAULT_TOPIC.slug) {
      searchParams = new URLSearchParams({
        topic: slug,
      })
    }

    setIsLoading(true)
    setActiveChip(slug)

    fetch(`/apiui/filterPostsByTopic/?${searchParams ? searchParams.toString() : ''}`)
      .then(res => res.json())
      .then(res => {
        setPosts([...res.posts])
        setIsLoading(false)
      })
      .catch(() => {
        setIsLoading(false)
      })
  }
  return (
    <ArticlesContext.Provider value={{ posts, activeChip, isLoading, fetchOnClick }}>
      {children}
    </ArticlesContext.Provider>
  )
}

const useArticlesContext = () => {
  return useContext(ArticlesContext)
}

export default useArticlesContext
